import Crud from '../views/Fornecedor/Crud'
import Entity from '../views/Fornecedor/Add'

let routes = {
    path: '/fornecedores',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/fornecedores/add',
            name: 'NewFornecedor',
            component: Entity,
            meta: {
                pageTitle: 'Fornecedores',
                breadcrumb: [
                    {
                        text: 'Fornecedores',
                        active: false,
                        to: '/fornecedores',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/fornecedores/edit/:id?',
            name: 'EditFornecedor',
            component: Entity,
            meta: {
                pageTitle: 'Fornecedores',
                breadcrumb: [
                    {
                        text: 'Fornecedores',
                        active: false,
                        to: '/fornecedores',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/fornecedores',
            name: 'list-fornecedores',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Fornecedores',
                breadcrumb: [
                    {
                        text: 'Fornecedores',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
